<template>
    <div class="form-group checkbox">
        <label :for="getFieldId">
            <input type="checkbox" :id="getFieldId" :name="name" @change="updateValue" :checked="value"> {{  placeholder }}
        </label>
    </div>
</template>
<script>

    let Input = require('@/mixins/InputField')

    export default {

        mixins: [Input],

        methods: {
            updateValue() {
                this.$emit('input', !this.value)
                this.$emit('change', !this.value)
            }
        }
    }
</script>
